/**
 * FR-017 — the link vocabulary (`libs/twin_links` LinkType) in the active
 * language (`twinLinks.linkTypes` in the locale files).
 *
 * One helper for every frontend surface that names a link type: the document's
 * "Verknüpfte Objekte", the add forms, and the farm object view's Belege
 * tiles. (The design-system `LinkedDocumentsPanel` carries its own copy — it
 * is a separate package.) A type with no entry must render its raw value, not
 * vanish.
 */
import i18n from '../i18n';

export function linkTypeLabel(linkType: string): string {
  const key = `twinLinks.linkTypes.${linkType}`;
  return i18n.exists(key) ? i18n.t(key) : linkType;
}
